import React from 'react';
import { useTranslation } from 'react-i18next';
import './LongShortBar.css';

/**
 * Long/Short Distribution Bar Component
 * Shows visual distribution of long vs short positions
 */
function LongShortBar({ longCount, shortCount, longValue, shortValue }) {
  const { t } = useTranslation();
  const total = longCount + shortCount;
  const totalValue = longValue + shortValue;
  // Calculate percentage by volume, not by count
  const longPercent = totalValue > 0 ? (longValue / totalValue) * 100 : 50;
  const shortPercent = 100 - longPercent;

  // Format large numbers
  const formatValue = (value) => {
    if (value >= 1000000000) {
      return `$${(value / 1000000000).toFixed(1)}B`;
    } else if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(1)}M`;
    } else if (value >= 1000) {
      return `$${(value / 1000).toFixed(0)}K`;
    }
    return `$${value}`;
  };

  return (
    <div className="long-short-bar">
      <div className="bar-header">
        <h3>{t('hyperliquid.distribution')}</h3>
        <div className="bar-totals">
          <span className="total-positions">{t('hyperliquid.totalPositions', { count: total })}</span>
          <span className="total-separator">•</span>
          <span className="total-value">{formatValue(longValue + shortValue)}</span>
        </div>
      </div>

      <div className="bar-container">
        <div
          className="bar-long"
          style={{ width: `${longPercent}%` }}
        >
          {longPercent > 15 && <span className="bar-label">{t('hyperliquid.longPercent', { percent: longPercent.toFixed(1) })}</span>}
        </div>
        <div
          className="bar-short"
          style={{ width: `${shortPercent}%` }}
        >
          {shortPercent > 15 && <span className="bar-label">{t('hyperliquid.shortPercent', { percent: shortPercent.toFixed(1) })}</span>}
        </div>
      </div>

      <div className="bar-stats">
        <div className="stat-long">
          <span className="stat-icon">↗</span>
          <div className="stat-details">
            <span className="stat-count">{t('hyperliquid.longCount', { count: longCount })}</span>
            <span className="stat-value">{formatValue(longValue)}</span>
          </div>
        </div>
        <div className="stat-short">
          <span className="stat-icon">↘</span>
          <div className="stat-details">
            <span className="stat-count">{t('hyperliquid.shortCount', { count: shortCount })}</span>
            <span className="stat-value">{formatValue(shortValue)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LongShortBar;
